import React from 'react';
import stores from '../../stores';

const { assessmentStore, assessmentInsightStore, assessmentEmployeesStoresFactory, assessmentInsightParticipantStoresFactory } = stores

export const assessmentTypes = {
    default: {
        isAssessmentInsight: false,
        name: 'assessment',
        title: 'Assessment',
        namePlural: 'assessments',
        titlePlural: 'Assessments',
        userName: 'employee',
        userNameTitle: 'Employee',
        userNamePlural: 'employees',
        userNamePluralTitle: 'Employees',
        parentRoute: '/assessment',
        noItemsDescription: 'Create a new assessment to measure and track employees’ cybersecurity knowledge and behavior.',
        deliveryDate: 'Delivery date',
        assessmentStore: assessmentStore,
        assessmentUsersStoresFactory: assessmentEmployeesStoresFactory,
    },
    hraInsight: {
        isAssessmentInsight: true,
        name: 'insight',
        title: 'Insight',
        namePlural: 'insights',
        titlePlural: 'Insights',
        userName: 'participant',
        userNameTitle: 'Participant',
        userNamePlural: 'participants',
        userNamePluralTitle: 'Participants',
        parentRoute: '/assessment-insight',
        deliveryDate: 'Created date',
        noItemsDescription: 'Create a new insight to measure and track audience cybersecurity knowledge and behavior.',
        assessmentStore: assessmentInsightStore,
        assessmentUsersStoresFactory: assessmentInsightParticipantStoresFactory,
    },
};

export const AssessmentContext = React.createContext(
    assessmentTypes.default
)